import BlVoucherCardMediumMv from './BlVoucherCardMediumMv.vue'

BlVoucherCardMediumMv.install = function(Vue) {
  Vue.component(BlVoucherCardMediumMv.name, BlVoucherCardMediumMv)
}

export default BlVoucherCardMediumMv
